import { OurStoryData } from './type'

export const ourStoryData: OurStoryData = {
  intro: {
    title: 'Our Story',
    subtitle: 'Hi, I\'m Carol. Mum, storyteller, and the heart behind Pixie World.',
    paragraphs: [
      'Like most parents, I want to create stories that reflect our own culture and values, while tapping into my daughters\' interests. But the books on the shelf never looked like us, and never included the grandparents, cousins, and friends who make our family who we are.',
      'So we built what we wished existed: a place where any family can create personalized stories that are as unique as they are.',
    ],
    founderImage: '/images/photoshoots/founder.webp',
  },
  mission: {
    pullQuote: 'We\'re not just making storybooks. We\'re helping families create personalized stories where every child sees themselves and the people they love.',
    paragraphs: [
      'Stories mean more when your child is at the center, surrounded by the people who matter most. A grandparent who lives far away, a best friend from school, a beloved pet, a favourite toy, and our stories bring them all into the adventure.',
      'You choose how characters look, who joins the adventure, and bring the story to life with characters that look just like your family. Your family\'s story is one of a kind, and the books on your shelf should be too.',
    ],
    imagePath: '/images/photoshoots/mermaid-sisters.webp',
  },
  team: {
    title: 'Meet Our Team',
    members: [
      {
        name: 'Amy',
        role: 'Chief Story Tester',
        bio: 'The little one with the wildest taste. Amy insists every story needs at least one crocodile and a spider or two (the scarier, the better). She tests every adventure at bedtime and won\'t approve it unless it gives her a good giggle. Her favourite part? Making sure her big sister is right there in the story with her.',
        imagePath: '/images/photoshoots/amy-fairy-2.jpg',
      },
      {
        name: 'Alice',
        role: 'Senior Story Critic',
        bio: 'The big sister who knows exactly what makes a story magical. Alice has strong opinions on which princesses are the best (all of them), demands fairies on every page, and insists her little sister joins every adventure. She provides critical feedback by reading each story at least five times and declaring "again!" until someone gives in.',
        imagePath: '/images/photoshoots/alice-fairy.jpg',
      },
    ],
    crew: [
      {
        name: 'Amy',
        role: 'Illustrator & Visual Storyteller',
        bio: 'Makes sure every pixel shines and every message lands with a sprinkle of magic.',
        imagePath: '/images/photoshoots/amy-marketer.webp',
      },
      {
        name: 'Uncle',
        role: 'Writer & Creative Technologist',
        bio: 'Turns caffeine into code and bugs into features. The wizard behind the curtain.',
        imagePath: '/images/photoshoots/uncle.webp',
      },
      {
        name: 'Eliyahu',
        role: 'Junior Artist & Apprentice Storyteller',
        bio: 'Armed with a magnifying glass and a keen eye, no bug escapes his watch.',
        imagePath: '/images/photoshoots/eliyahu.webp',
      },
    ],
    revealText: 'In case you haven\'t guessed, Amy and Alice are my daughters. They\'re the real reason Pixie World exists. Every feature we build, every story we create, gets tested at bedtime first. If it doesn\'t pass the "read it again!" test, it\'s back to the drawing board. They remind me every day why this matters: because every child deserves to be the hero of their own story.',
  },
  craft: {
    title: 'Handcrafted with Love',
    paragraphs: [
      'Every character in our stories starts as a pencil sketch, drawn and painted in watercolour by our illustration team. Each story is a collaboration between our artists, writers, and developers to bring your child\'s adventure to life.',
    ],
    imagePath: '/images/artist-process-sketch.webp',
  },
}
